import { render, staticRenderFns } from "./Paymentuseragreement.vue?vue&type=template&id=02468dda&scoped=true&"
import script from "./Paymentuseragreement.vue?vue&type=script&lang=js&"
export * from "./Paymentuseragreement.vue?vue&type=script&lang=js&"
import style0 from "./Paymentuseragreement.vue?vue&type=style&index=0&id=02468dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02468dda",
  null
  
)

export default component.exports